import { useEffect, useState } from "react";
import { JSONValidator } from "../../helper/Validators";

const PaymentFailure = () => {

    const [message, setMessage] = useState("")
    useEffect(() => {

        const postMessage = () => {

            setTimeout(() => {
                if (window.parent !== window) { // Ensure it's inside an iframe
                    window.parent?.postMessage(
                        { type: 'mobligo-payment-url-change', url: window.location.href, isSuccess: false },
                        "*" // Replace * with a specific origin for security
                    );
                }

            }, 5000)
        };
        console.log(window)
        const params = window.location.search
        const urlParams = new URLSearchParams(params);
        const body = urlParams.get("body")
        setMessage(JSONValidator(body))
        postMessage()
    }, [])

    return (
        <div class="bg-white p-6  md:mx-auto">
            <div className="bg-red-600 rounded-full flex items-center justify-center h-[140px] w-[140px] mx-auto">
                <svg version="1.1" width="80" height="80" viewBox="0 0 256 256" className="text-white stroke-white fill-white" >

                    <defs>
                    </defs>
                    <g transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
                        <path d="M 11 90 c -2.815 0 -5.63 -1.074 -7.778 -3.222 c -4.295 -4.296 -4.295 -11.261 0 -15.557 l 68 -68 c 4.297 -4.296 11.26 -4.296 15.557 0 c 4.296 4.296 4.296 11.261 0 15.557 l -68 68 C 16.63 88.926 13.815 90 11 90 z" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                        <path d="M 79 90 c -2.815 0 -5.63 -1.074 -7.778 -3.222 l -68 -68 c -4.295 -4.296 -4.295 -11.261 0 -15.557 c 4.296 -4.296 11.261 -4.296 15.557 0 l 68 68 c 4.296 4.296 4.296 11.261 0 15.557 C 84.63 88.926 81.815 90 79 90 z" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                    </g>
                </svg>
            </div>
            <div class="text-center">
                <h3 class="md:text-2xl text-base text-gray-900 font-semibold text-center">Ödeme Başarısız!</h3>
                <p class="text-gray-600 my-2">{message?.fail_message}</p>
            </div>
        </div>
    )
}
export default PaymentFailure